<template lang="html">
  <section class="formulario-momento-ganador" id="formulario">
    <h2 class="subtitle" v-if="finPromo != true">
      ¡Introduce tu código y participa!
    </h2>
    <template v-else>
      <h2 class="subtitle">Promoción finalizada</h2>
    </template>

    <div class="contenedor-input -code">
      <input
        :finPromo="finPromo"
        type="text"
        placeholder="Código"
        v-model="data.pincode"
        name="pincode"
        v-validate="'required|length:10'"
      />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("pincode")
      }}</span>
    </div>

    <div class="contenedor-input -mail" :full="result.esParticipanteNuevo">
      <input
        :finPromo="finPromo"
        type="email"
        class="-icon-email"
        placeholder="Email"
        v-model="data.email"
        name="email"
        @keyup.enter="validatepincode"
        v-validate="'required|email'"
      />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("email")
      }}</span>
    </div>

    <template v-if="result.esParticipanteNuevo">
      <div class="contenedor-input">
        <input
          type="text"
          placeholder="Nombre"
          v-validate="'required'"
          v-model="personales.nombre"
          name="nombre"
          class="-icon-user"
        />
        <span
          :class="['error', { 'animated shake': clicked }]"
          v-if="clicked"
          >{{ errors.first("nombre") }}</span
        >
      </div>

      <div class="contenedor-input">
        <input
          type="text"
          placeholder="Primer apellido"
          v-validate="'required'"
          v-model="personales.apellido1"
          name="primerapellido"
          class="-icon-user"
        />
        <span
          :class="['error', { 'animated shake': clicked }]"
          v-if="clicked"
          >{{ errors.first("primerapellido") }}</span
        >
      </div>

      <div class="contenedor-input">
        <input
          type="text"
          placeholder="Segundo apellido"
          v-model="personales.apellido2"
          name="segundoapellido"
          class="-icon-user"
        />
        <span
          :class="['error', { 'animated shake': clicked }]"
          v-if="clicked"
          >{{ errors.first("segundoapellido") }}</span
        >
      </div>

      <div class="contenedor-input">
        <input
          name="nacimiento"
          type="date"
          class="input-text -icon-fecha-nacimiento"
          v-validate="'required'"
          :placeholder="$t('formulario.fechanacimiento')"
          v-model="personales.fechaNacimiento"
        />
        <span class="error animated shake" v-if="errors.has('nacimiento')"
          >Este campo es requerido</span
        >
      </div>

      <div class="contenedor-radios row-center">
        <div class="contenedor-check">
          <input
            type="radio"
            id="sexo-hombre-momento"
            value="hombre"
            name="sexo"
            v-model="personales.sexo"
            v-validate="'required'"
          />
          <label for="sexo-hombre-momento">{{ $t("formulario.hombre") }}</label>
        </div>
        <div class="contenedor-check">
          <input
            type="radio"
            id="sexo-mujer-momento"
            value="mujer"
            name="sexo"
            v-model="personales.sexo"
            v-validate="'required'"
          />
          <label for="sexo-mujer-momento">{{ $t("formulario.mujer") }}</label>
        </div>
        <span class="error animated shake" v-if="errors.has('sexo')">{{
          errors.first("sexo")
        }}</span>
      </div>

      <div class="contenedor-input">
        <select
          name="provincia"
          id=""
          v-model="personales.idProvincia"
          class="select -icon-select-direccion"
          v-validate="'required'"
        >
          <option value="">Provincia</option>
          <option :value="provincia.clave" v-for="provincia in provincias">{{
            provincia.valor
          }}</option>
        </select>

        <span class="error animated shake" v-if="errors.has('provincia')">{{
          errors.first("provincia")
        }}</span>
      </div>

      <div class="contenedor-legal">
        <p>
          <strong
            >Información básica sobre Protección de datos Responsable:</strong
          >
          FIESTA COLOMBINA, S.L.U. Finalidad: Envío de información periódica de
          nuestras actividades, productos y/o servicios por medios electrónicos.
          Legitimación: Consentimiento del interesado. Destinatarios: No se
          cederán datos a terceros, salvo obligación legal Derechos: Acceder,
          rectificar, limitar y suprimir los datos, así como presentar una
          reclamación ante una autoridad de control, como se explica en la
          información adicional. Información Adicional: Puede consultar la
          información adicional y detallada sobre Protección de Datos en nuestra
          “Política de Privacidad”.
        </p>
      </div>
      <div class="legal">
        <p>
          Utilizamos cookies propias y de terceros para personalizar el
          contenido de la web, proporcionarles funcionalidades a las redes
          sociales y para analizar el tráfico de nuestra web. Puede aceptar el
          uso de esta tecnología o administrar su configuración y poder
          rechazarla, y así controlar completamente qué información se recopila
          y gestiona a través de los botones habilitados al efecto. Al clicar en
          "Sí, Acepto", ACEPTA SU USO, si bien podrá retirar su consentimiento
          en cualquier momento. También puede RECHAZAR la instalación de cookies
          clicando en “No Acepto" o CONFIGURAR la instalación de cookies
          clicando en “Configurar Cookies”. Para obtener más información sobre
          nuestras políticas de datos, visite nuestra
          <router-link :to="$t('enlaces.politica_privacidad')" target="_blank"
            >Política de privacidad</router-link
          >. Para obtener más información al respecto, puedes consultar nuestra
          <router-link :to="$t('enlaces.politica_cookies')" target="_blank"
            >Política de Cookies</router-link
          >.
        </p>
      </div>
      <div class="contenedor-check mt-0">
        <input type="checkbox" id="cookies" name="cookies" />
        <label for="cookies">Sí acepto las cookies</label>
      </div>
      <div class="contenedor-check" v-if="result.esParticipanteNuevo">
        <input
          type="checkbox"
          id="comunicaciones"
          name="comunicaciones"
          v-validate="'required'"
          v-model="personales.marketing"
        />
        <label for="comunicaciones"
          >Deseo recibir comunicaciones comerciales por parte de FIESTA</label
        >
        <span
          :class="['error', { 'animated shake': clicked }]"
          v-if="clicked"
          >{{ errors.first("comunicaciones") }}</span
        >
      </div>

      <a @click="validatepersonales" class="btn" :loading="loadingpersonales"
        >Participar</a
      >
    </template>

    <div class="contenedor-check" v-if="!!!result" :finPromo="finPromo">
      <input
        type="checkbox"
        id="politica"
        v-validate="'required'"
        name="politica"
        v-model="personales.privacy"
        :disabled="finPromo"
      />
      <label for="politica"
        >He leído y acepto la
        <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">
          política de privacidad
        </router-link>
        de FIESTA</label
      >
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("politica")
      }}</span>
    </div>

    <div class="contenedor-check" v-if="!!!result" :finPromo="finPromo">
      <input
        type="checkbox"
        id="bases"
        v-validate="'required'"
        name="bases"
        v-model="personales.base"
        :disabled="finPromo"
      />
      <label for="bases"
        >He leído y acepto las
        <a href="https://terms.easypromosapp.com/t/48913" target="_blank"
          >bases legales de la promoción</a
        ></label
      >
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("bases")
      }}</span>
    </div>

    <div class="contenedor-boton" v-if="!!!result">
      <a
        @click="validatepincode"
        class="btn"
        :loading="loadingcode"
        :finPromo="finPromo"
        >Comprobar</a
      >
    </div>

    <img
      src="/static/img/momento-ganador/kojak-abierto.gif"
      alt="Freskito"
      class="freskito"
    />
    <img
      src="/static/img/momento-ganador/kojak.png"
      alt="Kojak"
      class="kojak"
    />
  </section>
</template>

<script lang="js">

import { mapActions, mapGetters } from 'vuex';

import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
    name: 'formulario-momento-ganador',
    data() {
        return {
            showanimation: false,
            clicked: false,
            loadingcode: false,
            loadingpersonales: false,
            finPromo:false,
            data: {
                email: '',
                pincode: ''
            },
            personales: {
                nombre: '',
                apellidos: '',
                email: '',
                cp: '',
                idProvincia: '',
                apellido1: '',
                apellido2: '',
                sexo: '',
                fechaNacimiento: '',
                base: false,
                marketing: false,
                privacy: false
            }
        }
    },
    mounted() {
        const fechaActual = new Date().getTime();
        const fechaInicio = new Date(2023, 8, 16).getTime();

        if (fechaActual >= fechaInicio) {
            this.finPromo = true
        }

        setTimeout(e => {
            this.showanimation = true;
        }, 1000)

    },
    computed: {
        ...mapGetters({
            provincias: 'getProvincias',
            result: 'getResultParticipacion'
        })
    },
    methods: {
        ...mapActions(['sendParticipacion', 'sendDatosPersonales', 'sendRegistro', 'sendNewsletterGeneric']),
        validatepincode: function () {

            this.clicked = true;
            this.$validator.validateAll().then(canSend => {
                if (canSend) {
                    this.loadingcode = true;
                    this.sendParticipacion(this.data)
                        .then(result => {

                            if (!!result) {
                                if (!!!result.esParticipanteNuevo) {
                                    this.$emit("finish");
                                }
                            }
                            this.loadingcode = false;
                        });
                }
            });
        },
        validatepersonales: function () {
            this.clicked = true;
            this.$validator.validateAll().then(canSend => {
                if (canSend) {
                    this.loadingpersonales = true;
                    this.sendNewsletter();
                }
            });
        },
        sendNewsletter() {

            let provincia = this.provincias.filter(p => p.clave == this.personales.idProvincia)[0].valor

            let datanewsletter = {
                id: 6,
                email: this.data.email,
                name: this.personales.nombre,
                firstName: this.personales.apellido1,
                lastName: this.personales.apellido2,
                province: provincia,
                sex: this.personales.sexo,
                birthday: this.personales.fechaNacimiento,
                base: this.personales.base,
                marketing: this.personales.marketing,
                privacy: this.personales.privacy

            }

            this.sendNewsletterGeneric(datanewsletter).then(r => {
                let fecha = new Date(this.personales.fechaNacimiento);

                this.personales.fechaNacimiento = `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`

                this.sendRegistro(this.personales)
                    .then(result => {
                        this.loadingpersonales = false;
                        if (!!result) {
                            this.$emit("finish");
                        }
                    });
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/formulario.vue